//友盟SDK参数
export namespace UMA_SDK {
    export const APP_KEY: string = '60e2a4818a102159db886a82';
}